import { useCallback } from 'react';
import { useConfig } from '../../contexts/ConfigContext';
import { LoginForm } from '../LoginForm';

export const ConfigSection = () => {
  const {
    token,
    setToken,
    setRefreshToken,
    projectId,
    setProjectId,
    apiUrl,
    setApiUrl,
    tokenApiUrl,
    setTokenApiUrl,
  } = useConfig();

  const handleLoginSuccess = useCallback(
    (newToken: string, newRefreshToken: string) => {
      setToken(newToken);
      setRefreshToken(newRefreshToken);
      // Pin the URL the token was issued by — input may drift later.
      setTokenApiUrl(apiUrl.replace(/\/+$/, ''));
    },
    [setToken, setRefreshToken, setTokenApiUrl, apiUrl],
  );

  const inputClass =
    'bg-[#0d1117] border border-[#30363d] text-[#c9d1d9] px-2.5 py-2 rounded-md text-sm font-mono w-full focus:outline-none focus:border-[#58a6ff]';

  return (
    <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-4 mb-4">
      <h2 className="text-sm text-[#8b949e] uppercase tracking-wide mb-3">
        Configuration
      </h2>
      <div className="flex gap-3 mb-2.5 flex-wrap">
        <div className="flex-1 min-w-[180px]">
          <label className="block text-[12px] text-[#8b949e] mb-1">
            API Base URL
          </label>
          <input
            type="text"
            className={inputClass}
            value={apiUrl}
            onChange={(e) => setApiUrl(e.target.value)}
            placeholder="http://localhost:5050"
          />
        </div>
        <div className="w-[160px] flex-none">
          <label className="block text-[12px] text-[#8b949e] mb-1">
            Project ID
          </label>
          <input
            type="number"
            className={inputClass}
            value={projectId}
            onChange={(e) => setProjectId(e.target.value)}
            placeholder="e.g. 3"
          />
        </div>
      </div>
      <LoginForm apiUrl={apiUrl} onLoginSuccess={handleLoginSuccess} />
      {token && (
        <div className="text-[11px] text-[#3fb950]">
          Authenticated against{' '}
          <span className="font-semibold">
            {tokenApiUrl || '(unknown — log in again to refresh)'}
          </span>{' '}
          (token auto-refreshes on expiry)
        </div>
      )}
    </div>
  );
};
